import { Link } from "react-router-dom";
import { Tick } from "@/components/app/Tick";

export const SMS_CONSENT_TEXT =
  "I agree to receive text messages from ResidenceProof at the phone number provided, including account updates, " +
  "promotional messages and marketing campaigns. Message frequency varies. Message and data rates may apply. " +
  "Reply STOP to opt out or HELP for help. Consent is not a condition of purchase or of using our services.";

const TermsLinks = () => (
  <>
    See our{" "}
    <Link to="/messaging-terms" className="text-oath-accent underline" data-testid="sms-messaging-terms-link">Messaging Terms</Link> and{" "}
    <Link to="/privacy" className="text-oath-accent underline" data-testid="sms-privacy-link">Privacy Policy</Link>.
  </>
);

export const SmsConsentBox = ({ checked, onToggle }) => (
  <div className="mt-5" data-testid="sms-consent">
    <Tick checked={checked} onToggle={onToggle} testid="sms-consent-checkbox" label="Text me updates (optional)" hint={SMS_CONSENT_TEXT} />
    <p className="mt-2 text-xs text-oath-muted"><TermsLinks /></p>
  </div>
);

export const SmsTermsNotice = () => (
  <p className="mt-4 text-xs leading-relaxed text-oath-muted" data-testid="sms-terms-notice">
    By signing in you agree to our <Link to="/terms" className="text-oath-accent underline" data-testid="sms-terms-link">Terms of Use</Link>.
    If you have opted in to text messages from ResidenceProof: message frequency varies, message and data rates may apply,
    reply STOP to opt out or HELP for help. <TermsLinks />
  </p>
);
